import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Divider from '@mui/material/Divider';
import StatsHeaderDesktop from './StatsHeaderDesktop';

const numberFormat = new Intl.NumberFormat('en-US');

const ServiceableLocationsTotal = ({ mobile }) => {
  const selection = useSelector((state) => state.mainControls.selection);
  const statewideData = useSelector((state) => state.statewideData?.feature?.properties);
  const [serviceableLocations, setServiceableLocations] = useState('');

  useEffect(() => {
    if (selection) {
      setServiceableLocations(numberFormat.format(selection.serviceable_locations));
    } else if (statewideData) {
      setServiceableLocations(numberFormat.format(statewideData.serviceable_locations));
    }
  }, [selection, statewideData]);

  return (
    <>
      <div
        style={{
          width: '100%',
          height: mobile ? '5%' : 'calc(11% - 20px)',
          marginBottom: mobile ? 10 : 10,
          padding: 5,
          background: '#22467F',
          borderRadius: 5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <StatsHeaderDesktop />
        <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 2 }} />
        <div>
          <div style={{ margin: 3, fontSize: 16 }}>
            Total Serviceable Locations: &nbsp;
            {serviceableLocations}
          </div>
        </div>

      </div>
    </>

  );
};

export default ServiceableLocationsTotal;
